// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.jira-navbar {
    background-color: #fff !important;
    border-bottom: 1px solid #dfe1e6;
    padding: 10px 0;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  }
  
  .jira-logo {
    border-radius: 4px;
  }
  
  .jira-brand {
    font-size: 1.25rem;
    font-weight: 600;
    color: #172b4d;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  
  .jira-toggle {
    border-color: #dfe1e6;
  }
  
  .jira-nav-link {
    color: black !important;
    /* font-weight: 500; */
    font-weight: bolder;
    padding: 8px 16px !important;
   
    transition: background-color 0.2s, color 0.2s;
  }
  
  .jira-nav-link:hover {
    background-color: #f4f5f7;
    color: #003d99 !important;
    border-radius: 4px;
  }
  
  .jira-logout-btn {
    font-size: 14px;
    padding: 6px 12px;
    border-color: #d93025;
    color: #d93025;
    font-weight: 500;
  }
  
  .jira-logout-btn:hover {
    background-color: #d93025;
    color: #fff;
    border-color: #d93025;
  }
  
  .navbar-collapse {
    transition: all 0.3s ease-in-out;
  }
  
  /* Mobile adjustments */
  @media (max-width: 991px) {
    .jira-nav-link {
      padding: 10px 20px !important;
    }
    .jira-logout-btn {
      margin: 10px 20px;
      width: calc(100% - 40px);
    }
  }`, "",{"version":3,"sources":["webpack://./src/Styles/CustomNavbar.css"],"names":[],"mappings":"AAAA;IACI,iCAAiC;IACjC,gCAAgC;IAChC,eAAe;IACf,yCAAyC;EAC3C;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;EACzB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,uBAAuB;IACvB,sBAAsB;IACtB,mBAAmB;IACnB,4BAA4B;;IAE5B,6CAA6C;EAC/C;;EAEA;IACE,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,qBAAqB;IACrB,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;IACzB,WAAW;IACX,qBAAqB;EACvB;;EAEA;IACE,gCAAgC;EAClC;;EAEA,uBAAuB;EACvB;IACE;MACE,6BAA6B;IAC/B;IACA;MACE,iBAAiB;MACjB,wBAAwB;IAC1B;EACF","sourcesContent":[".jira-navbar {\n    background-color: #fff !important;\n    border-bottom: 1px solid #dfe1e6;\n    padding: 10px 0;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n  }\n  \n  .jira-logo {\n    border-radius: 4px;\n  }\n  \n  .jira-brand {\n    font-size: 1.25rem;\n    font-weight: 600;\n    color: #172b4d;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n  \n  .jira-toggle {\n    border-color: #dfe1e6;\n  }\n  \n  .jira-nav-link {\n    color: black !important;\n    /* font-weight: 500; */\n    font-weight: bolder;\n    padding: 8px 16px !important;\n   \n    transition: background-color 0.2s, color 0.2s;\n  }\n  \n  .jira-nav-link:hover {\n    background-color: #f4f5f7;\n    color: #003d99 !important;\n    border-radius: 4px;\n  }\n  \n  .jira-logout-btn {\n    font-size: 14px;\n    padding: 6px 12px;\n    border-color: #d93025;\n    color: #d93025;\n    font-weight: 500;\n  }\n  \n  .jira-logout-btn:hover {\n    background-color: #d93025;\n    color: #fff;\n    border-color: #d93025;\n  }\n  \n  .navbar-collapse {\n    transition: all 0.3s ease-in-out;\n  }\n  \n  /* Mobile adjustments */\n  @media (max-width: 991px) {\n    .jira-nav-link {\n      padding: 10px 20px !important;\n    }\n    .jira-logout-btn {\n      margin: 10px 20px;\n      width: calc(100% - 40px);\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
